//@ts-nocheck

export const getLocalTenantData = () => {
  try {
    const localStorageData = localStorage.getItem('tenantData');
    if (localStorageData) {
      return JSON.parse(localStorageData);
    }
  } catch (error) {
    return null;
  }
};
